import s from "./header.module.css";
import shadowImg from "../../../assets/eagleShadow.png";
import "animate.css";
import { useState } from "react";

export default function Header({ setColorFondo, colorFondo }) {
  const [clickme, setClickme] = useState(false);
  let [index, setIndex] = useState(0);
  // let images = [image1, image2,image3, image4, image5, image6]
  let frases = ["Venom", "soldiers", "global", "art", "nft", "web3"];
  let colors = ["beige", "skyblue", "pink", "violet", "orange", "green"];

  const handleClick = () => {
    setClickme(true)
    setIndex((prevIndex)=>{
        if(prevIndex === 5){
            // setColorFondo("beige")
            return 0
        } 
        else{ 
            return ++prevIndex
        }
    })
    index === 5 ? setColorFondo(colors[0]) : setColorFondo(colors[++index])
  };
  return (
    <header className={s[colorFondo]}>
      <div className={s.container}>
        <div onClick={() => handleClick()} className={s.imageContainer}>
          <span className={s.coming} onClick={() => handleClick()}>
            {!clickme ? "click me" : "coming soon"}
          </span>
          <img
            className={s.image}
            draggable={false}
            src={shadowImg}
            alt="nft"
            onClick={() => handleClick()}
          />
        </div>
        <div className={s.textContainer}>
          <span className={s.text}>{frases[index]}</span>
          <span className={s.text}>INVASION</span>
        </div>
      </div>
    </header>
  );
}
